import * as types from './actionTypes';

export function successNotificationBanner(banner) {
  return {
    type: types.NOTIFICATION_SUCCESS,
    banner,
  };
}

export function closeNotificationBanner() {
  return {
    type: types.NOTIFICATION_DISMISS,
  };
}

export function dangerNotificationBanner(banner) {
  return {
    type: types.NOTIFICATION_DANGER,
    banner,
  };
}


export function cardNumberNotificationBanner(banner) {
  return {
    type: types.NOTIFICATION_ACCOUNT_NUMBER,
    banner,
  };
}

export function warningNotificationBanner(banner) {
  return {
    type: types.NOTIFICATION_DANGER,
    banner,
  };
}
export function addManualTransactionNotificationBanner(banner){
  return {
    type: types.NOTIFICATION_MANUAL_TRANSACTION,
    banner,
  };
}
export function addInternalCaseNotificationBanner(banner){
  return {
    type: types.NOTIFICATION_TAKE_ACTION_INTERNAL_CASE,
    banner,
  };
}